import React from "react";
import { IChildren } from "@components/interfaces/IChildren";
import "./Container.scss";

const Container = ({ children }: IChildren) => {
  return <div className="container">{children}</div>;
};

export default Container;
